import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Project extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getAcountProfileUser(params) {
    return this.httpService.get("Acounts/profile-user", { headers, params });
  }

  getAllProjectList(params) {
    return this.httpService.get("Project/all-project", { headers, params });
  }

  getAllProjectCustomerList(params) {
    params.IsWithHistory = true;
    return this.httpService.get("Project/all-project-customer", {
      headers,
      params,
    });
  }

  getProjectInfo(params) {
    return this.httpService.get("Project/select-project", { headers, params });
  }
  getStateProjectList(params) {
    return this.httpService.get("Project/com-state-project", {
      headers,
      params,
    });
  }
  getStateProjectAll(params) {
    return this.httpService.get("Definition/all-state-project", {
      headers,
      params,
    });
  }

  insertProject(data) {
    return this.httpService.post("Project/insert-project", data, { headers });
  }

  insertProjectGuest(data) {
    return this.httpService.post("Project/insert-project-guest", data, {
      headers,
    });
  }

  deleteProject(data) {
    return this.httpService.delete("Project/delete-project", { headers, data });
  }

  updateProject(data) {
    return this.httpService.put("Project/update-project", data, { headers });
  }

  updateStateProjectUser(data) {
    return this.httpService.put("Project/change-state-project-user", data, {
      headers,
    });
  }

  InserRequestStateProjectUser(data) {
    return this.httpService.post("Project/send-request-state", data, {
      headers,
    });
  }

  selectUserGroupCombo(params) {
    return this.httpService.get("Acounts/select-group-user-combo", {
      headers,
      params,
    });
  }

  selectProjectComboInUser(params) {
    return this.httpService.get("Project/combo-project-user", {
      headers,
      params,
    });
  }

  getAllProjectUserWithAdmin(params) {
    return this.httpService.get("Project/select-project-user-with-admin", {
      headers,
      params,
    });
  }

  selectProjectComboWitIdCustomer(params) {
    return this.httpService.get("Project/combo-project-customer", {
      headers,
      params,
    });
  }

  selectStateMasterWizard(params) {
    return this.httpService.get("Project/combo-group-master-wizard", {
      headers,
      params,
    });
  }

  selectStateSlaveWizard(params) {
    return this.httpService.get("Project/combo-group-slave-wizard", {
      headers,
      params,
    });
  }

  InsertStateProjectWizard(data) {
    return this.httpService.post("Project/add-state-project-wizard", data, {
      headers,
    });
  }

  selectStateMasterAndSlaveProjectWizard(params) {
    return this.httpService.get("Project/get-state-project-wizard", {
      headers,
      params,
    });
  }

  GetListUnitWizardForSlave(params) {
    return this.httpService.get("Project/list-unit-template-wizard", {
      headers,
      params,
    });
  }

  getLastProjectInfo(params) {
    return this.httpService.get("Project/last-project", { headers, params });
  }

  getProjectProfit(params) {
    return this.httpService.get("/Project/profit", { headers, params });
  }

  getCalculationProfit(params) {
    return this.httpService.get("/Project/calc-profit", { headers, params });
  }

  updateProjectUnitListOrder(data) {
    return this.httpService.put("Project/order-unit", data, {
      headers,
    });
  }

}
const ProjectService = new Project();
export default ProjectService;
